import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBUxD0dcEOlrvjwr5FGOvy5Yfk80zBcx6I",
  authDomain: "gestion-obras-particulares.firebaseapp.com",
  projectId: "gestion-obras-particulares",
  storageBucket: "gestion-obras-particulares.appspot.com",
  messagingSenderId: "287969862390",
  appId: "1:287969862390:web:547859a6f20eb402d142d7",
  measurementId: "G-N6NVGDPNMH",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
